(() => {
  const emptyReviewPattern = /^(no reviews?|noch keine(?: produkt)?bewertungen?|noch keine produktbewertung)$/i;

  const hideEmptyReviewBadges = (root = document) => {
    root
      .querySelectorAll?.('.jdgm-preview-badge, .jdgm-prev-badge, .jdgm-widget')
      .forEach((badge) => {
        const countNode = badge.matches('[data-number-of-reviews]')
          ? badge
          : badge.querySelector('[data-number-of-reviews]');
        const countValue = countNode?.getAttribute('data-number-of-reviews');
        const text = badge.textContent.replace(/\s+/g, ' ').trim();
        const isEmptyCount = countValue !== null && Number(countValue) === 0;
        const isEmptyText = emptyReviewPattern.test(text);

        if (isEmptyCount || isEmptyText) {
          badge.setAttribute('data-ff-empty-reviews', 'true');
          const wrapper = badge.closest('.jdgm-preview-badge, .jdgm-widget');
          wrapper?.setAttribute('data-ff-empty-reviews', 'true');
        }
      });
  };

  const start = () => {
    hideEmptyReviewBadges();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) hideEmptyReviewBadges(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
